import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/motion";
import { CheckCircle2, ArrowUpRight } from "lucide-react";

const POINTS = [
  "Connect with suitable, eligible prospective learners",
  "Efficient, transparent and largely automated admissions",
  "Reduce administrative workload for your teams",
];

export const Universities = () => (
  <section id="universities" data-testid="universities-section" className="relative py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-[28px] border border-slate-200 shadow-[0_30px_80px_rgba(10,37,64,0.12)]">
            <img
              src="https://images.unsplash.com/photo-1575688588571-966e9b61f0b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="Modern university campus"
              className="h-[460px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-cobalt/30 via-transparent to-transparent" />
          </div>
          <div className="absolute -left-4 -bottom-4 h-24 w-24 rounded-full bg-cobalt/20 blur-2xl" />
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">For Education Providers</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
              Built for Modern<br />Learner Recruitment
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-slatey">
              OpenDegree is developing a technology-driven recruitment platform designed to help education providers
              connect with suitable prospective learners through an efficient, transparent and largely automated
              admissions process.
            </p>
          </Reveal>

          <ul className="mt-8 space-y-3.5">
            {POINTS.map((p, i) => (
              <Reveal key={i} delay={0.15 + i * 0.07} className="flex items-start gap-3">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-cobalt" />
                <span className="text-[15px] text-ink">{p}</span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.35}>
            <div className="mt-9 rounded-2xl border border-cobalt/20 bg-cobalt/5 p-5">
              <p className="text-sm font-semibold text-ink">We're currently seeking partnerships with UK higher education providers.</p>
              <Link
                data-testid="universities-partnership-btn"
                to="/partner"
                className="group mt-4 inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:scale-[1.03] active:scale-95"
              >
                Partner With Us
                <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
